import { useEffect, useState } from "react";
import { Separator } from "@/Components/ui/separator";
import { Item, MainProduct, Option, Stage } from "@/types/productTypes";
import { useAdminStore } from "../../../store/useAdminStore";
import ConfigEditor from "./ConfigEditor";
import ImageEditor from "./SubEditors/ImageEditor";
import ImageManager from "../ImageManager/ImageManager";
import CategoryEditor from "./categories/CategoryEditor";
export type MainEditorPanelProps = {
   currentProduct: MainProduct | null | undefined;
   currentStage: Stage | null;
   currentOption: Option | null;
   currentItem: Item | null;
};

export type ControlHover = {
   type: "Stage" | "Option" | "Item";
   stageId: number | null;
   optionId: number | null;
   itemId: number | null;
};

export default function MainEditorPanel({
   currentProduct,
   currentStage,
   currentOption,
   currentItem,
}: MainEditorPanelProps) {
   const [controlHovered, setControlHovered] = useState<ControlHover | null>(
      null
   );
   const adminStore = useAdminStore();

   const onControlMouseDown = (e: React.MouseEvent) => {
      if (!e.ctrlKey) return;
      e.stopPropagation();
      e.preventDefault();

      if (!controlHovered) return;

      switch (controlHovered.type) {
         case "Stage":
            if (controlHovered.stageId) {
               adminStore.selectStage(controlHovered.stageId);
            }
            break;
         case "Option":
            if (controlHovered.stageId && controlHovered.optionId) {
               adminStore.selectOption(
                  controlHovered.stageId,
                  controlHovered.optionId
               );
            }
            break;
         case "Item":
            if (
               controlHovered.stageId &&
               controlHovered.optionId &&
               controlHovered.itemId
            ) {
               adminStore.selectItem(
                  controlHovered.stageId,
                  controlHovered.optionId,
                  controlHovered.itemId
               );
            }
            break;
         default:
            break;
      }
   };

   useEffect(() => {
      const handleGlobalClick = (e: MouseEvent) => {
         if (
            e.ctrlKey &&
            e.target instanceof HTMLElement &&
            e.target.tagName === "I"
         ) {
            // Optionally, trigger some global behavior here.
         }
      };

      window.addEventListener("mousedown", handleGlobalClick);
      return () => {
         window.removeEventListener("mousedown", handleGlobalClick);
      };
   }, []);

   // Determine which editor to render
   let editorContent;
   if (adminStore.imagePage && currentStage) {
      editorContent = (
         <div className="w-full">
            <ImageEditor stage={currentStage} />
         </div>
      );
   } else if (adminStore.imageManagerPage) {
      editorContent = <ImageManager />;
   } else if (adminStore.showCategories) {
      editorContent = <CategoryEditor />;
   } else {
      editorContent = (
         <ConfigEditor
            currentProduct={currentProduct}
            currentStage={currentStage}
            currentOption={currentOption}
            currentItem={currentItem}
            setControlHovered={setControlHovered}
            controlHovered={controlHovered}
         />
      );
      console.log("editorContent 1");
   }
   console.log("editorContent 2", editorContent);
   return (
      <div className="w-full flex flex-col max-h-screen overflow-hidden">
         <ChooseImageOrEditor />
         <div
            className="w-full flex overflow-auto"
            onMouseDown={onControlMouseDown}
         >
            {editorContent}
         </div>
      </div>
   );
}

type ChooseImageOrEditorProps = {};

export function ChooseImageOrEditor({}: ChooseImageOrEditorProps) {
   const adminStore = useAdminStore();

   return (
      <div className="w-full h-16 bg-gray-100 flex items-center justify-center border-b border-gray-300 shadow-sm p-2">
         <div className="flex items-center gap-6 w-full max-w-lg">
            {/* Item Editor Button */}
            <button
               className={`flex-1 px-4 py-2 text-center rounded-lg font-medium text-sm transition ${
                  !adminStore.imagePage
                     ? "bg-gray-500 text-white shadow-md"
                     : "bg-gray-200 text-gray-600 hover:bg-gray-300"
               }`}
               onClick={() => adminStore.setImagePage(false)}
            >
               Item Editor
            </button>
            <Separator orientation="vertical" className="h-8 bg-gray-400" />
            {/* Image Editor Button */}
            <button
               className={`flex-1 px-4 py-2 text-center rounded-lg font-medium text-sm transition ${
                  adminStore.imagePage
                     ? "bg-gray-500 text-white shadow-md"
                     : "bg-gray-200 text-gray-600 hover:bg-gray-300"
               }`}
               onClick={() => adminStore.setImagePage(true)}
            >
               Image Editor
            </button>
         </div>
      </div>
   );
}
